window.BH_QUIZ_DATA = {
  chapters: ['Your hair', 'Your scalp', 'The change'],
  questions: [
    { c:0, t:'What has changed most?', s:'Pick the one that bothers you most.', multi:false, id:'change',
      o:[['finer','It feels finer than it used to'],
         ['shed','I am shedding more than usual'],
         ['both','Both, and they started around the same time'],
         ['dry','Neither. It is mostly dry and brittle']] },

    { c:0, t:'Where do you notice it?', s:'', multi:false, id:'where',
      o:[['part','At the parting'],
         ['temples','At the temples or hairline'],
         ['allover','Spread across the whole head'],
         ['ends','Mostly the ends breaking off']] },

    { c:0, t:'How long is your hair?', s:'', multi:false, id:'length',
      o:[['short','Above the shoulder'],
         ['mid','About shoulder length'],
         ['long','Past the shoulder'],
         ['xlong','Mid-back or longer']] },

    { c:0, t:'What does one strand feel like?', s:'Roll a single hair between your fingers.', multi:false, id:'strand',
      o:[['fine','I can barely feel it'],
         ['medium','I can feel it, but only just'],
         ['coarse','Distinctly textured']] },

    { c:0, t:'How often do you wash it?', s:'', multi:false, id:'wash',
      o:[['daily','Every day'],
         ['often','Every two or three days'],
         ['twice','About twice a week'],
         ['weekly','Once a week or less']] },

    { c:1, t:'Between washes, your scalp is...', s:'Scalps change through the change, often more than hair does.', multi:false, id:'scalp',
      o:[['oily','Oily sooner than it used to be'],
         ['balanced','About the same as always'],
         ['dry','Dry, sometimes tight'],
         ['mixed','Oily and flaky at the same time']] },

    { c:1, t:'Is your scalp sensitive?', s:'Tightness, itching, stinging or redness all count.', multi:false, id:'sensitive',
      o:[['often','Yes, often'],
         ['sometimes','Sometimes'],
         ['no','Not really']] },

    { c:1, t:'Do you get flaking?', s:'', multi:false, id:'flake',
      o:[['yes','Yes, regularly'],
         ['some','Occasionally'],
         ['no','No']] },

    { c:1, t:'Any of these apply to your hair?', s:'Select all that apply.', multi:true, id:'treat',
      o:[['colour','It is colour-treated'],
         ['heat','I use heat tools most weeks'],
         ['tight','I often wear it up or tied back'],
         ['chem','It has been chemically straightened or relaxed'],
         ['none','None of these']] },

    { c:2, t:'Where are you in the change?', s:'There is no wrong answer, and you can say you are unsure.', multi:false, id:'stage',
      o:[['pre','I have not noticed changes yet'],
         ['peri','Perimenopause — cycles changing'],
         ['meno','Menopause'],
         ['post','Post-menopause'],
         ['unsure','I am not sure']] },

    { c:2, t:'When did your hair start changing?', s:'', multi:false, id:'when',
      o:[['recent','In the last six months'],
         ['year','Six to twelve months ago'],
         ['few','One to three years ago'],
         ['long','More than three years ago']] },

    { c:2, t:'What matters most to you?', s:'Select all that apply.', multi:true, id:'goal',
      o:[['fullness','More fullness at the parting'],
         ['shedding','Less shedding'],
         ['breakage','Less breakage'],
         ['calm','A calmer, more comfortable scalp']] }
  ]
};
